import { render, staticRenderFns } from "./DataValidation.vue?vue&type=template&id=1df6b2dc&"
import script from "./DataValidation.vue?vue&type=script&lang=js&"
export * from "./DataValidation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports